import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2c0197f8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0197f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0197f8')) {
      api.createRecord('2c0197f8', component.options)
    } else {
      api.reload('2c0197f8', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2c0197f8&scoped=true", function () {
      api.rerender('2c0197f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tutorial/detail.vue"
export default component.exports